import Resize from '@/mixins/Resize'

export default
{
    mixins:
    [
        Resize
    ],

    watch:
    {
        $route()
        {
            this.$store.isMenuOpen = false
        }
    },

    computed:
    {
        isServicePage()
        {
            return this.$route.name === 'mining'
                || this.$route.name === 'automation'
                || this.$route.name === 'ia'
        }
    },

    methods:
    {
        onResized(width)
        {
            if (width > 728 && this.$store.isMenuOpen)
            {
                this.$store.isMenuOpen = false
            }
        }
    }
}
